import { useRef } from 'react'
import { gsap, ScrollTrigger, useGSAP } from '../lib/gsap'
import Logo from './Logo'

// Infinite row that drifts on its own, speeds up and skews with scroll velocity, and flips with scroll direction.
export default function VelocityMarquee({ items, baseSpeed = 40, reverse = false, outline = false, className = '' }) {
  const root = useRef(null)
  const track = useRef(null)

  useGSAP(
    () => {
      let x = 0
      let dir = reverse ? 1 : -1
      let boost = 0
      const skewTo = gsap.quickTo(track.current, 'skewX', { duration: 0.6, ease: 'power3.out' })
      let half = track.current.scrollWidth / 2
      const ro = new ResizeObserver(() => (half = track.current.scrollWidth / 2))
      ro.observe(track.current)

      const st = ScrollTrigger.create({
        trigger: root.current,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: (self) => {
          const v = self.getVelocity()
          dir = (self.direction === 1 ? -1 : 1) * (reverse ? -1 : 1)
          boost = Math.min(Math.abs(v) / 18, 220)
          skewTo(gsap.utils.clamp(-12, 12, v / -260))
        },
      })

      const tick = (_, dt) => {
        if (!st.isActive) return
        boost *= 0.93
        if (Math.abs(boost) < 1) skewTo(0)
        x += dir * (baseSpeed + boost) * (dt / 1000)
        const w = half
        if (w > 0) x = gsap.utils.wrap(-w, 0, x)
        gsap.set(track.current, { x })
      }
      gsap.ticker.add(tick)
      return () => {
        gsap.ticker.remove(tick)
        ro.disconnect()
      }
    },
    { scope: root },
  )

  const row = items.map((item, i) => (
    <span key={i} className="flex items-center">
      <span
        className={`whitespace-nowrap px-6 font-display text-[clamp(3rem,9vw,8.5rem)] font-semibold uppercase leading-none tracking-[-0.04em] sm:px-10 ${outline ? 'text-outline' : 'text-white'}`}
      >
        {item}
      </span>
      <Logo className="h-[clamp(1.6rem,4vw,3.6rem)] w-[clamp(1.6rem,4vw,3.6rem)] shrink-0" variant={outline ? 'outline' : 'gradient'} strokeWidth={1} />
    </span>
  ))

  return (
    <div ref={root} className={`overflow-hidden py-3 ${className}`} aria-hidden>
      <div ref={track} className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  )
}
